









import {
  defineComponent, Ref, ref, watch,
} from '@vue/composition-api';
import type { PropType } from '@vue/composition-api';

import type { Driver } from '@/useDeliveryNote';
import type { Vehicle } from '@/useVehicle';

import ResourceSelectorInput from '@/components/DeliveryNote/ResourceSelectorInput.vue';

const VehicleSelectorInput = defineComponent({
  components: {
    ResourceSelectorInput,
  },
  props: {
    value: {
      type: Object as PropType<Vehicle>,
      default: () => undefined,
    },
    variables: { default: () => ({}) },
  },
  setup(props, { emit }) {
    const internalValue: Ref<{ vehicle: Vehicle | undefined; driver: Driver | undefined }> = ref({
      vehicle: undefined,
      driver: undefined,
    });
    watch(() => props.value, (newVal, oldVal) => {
      if (newVal !== oldVal) {
        internalValue.value = {
          vehicle: newVal as any,
          driver: undefined,
        };
      }
    });

    function updateVehicle($event: { vehicle: Vehicle | undefined; driver: Driver | undefined }) {
      emit('input', $event.vehicle);
    }

    return {
      internalValue,
      updateVehicle,
    };
  },
});

export default VehicleSelectorInput;
